import type { App } from 'vue';
import tableToolbar from './src/index.vue';

export const TableToolbar = Object.assign(tableToolbar, {
  install(app: App) {
    app.component(tableToolbar.name, tableToolbar);
  },
});

export default {
  TableToolbar,
};
